import * as React from 'react';
import Alert from './Alert';
class ErrorBoundary extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            error: undefined,
            info: {
                componentStack: '',
            },
        };
    }
    componentDidCatch(error, info) {
        this.setState({ error, info });
    }
    render() {
        const { message, description, id, children } = this.props;
        const { error, info } = this.state;
        const componentStack = info && info.componentStack ? info.componentStack : null;
        const errorMessage = typeof message === 'undefined' ? (error || '').toString() : message;
        const errorDescription = typeof description === 'undefined' ? componentStack : description;
        if (error) {
            return (React.createElement(Alert, { id: id, type: "error", message: errorMessage, description: React.createElement("pre", { style: { fontSize: '0.9em', overflowX: 'auto' } }, errorDescription) }));
        }
        return children;
    }
}
export default ErrorBoundary;
